import api from '../api'

// http://plickers-api-documentation-pgjd3e8jb7.s3-website-us-east-1.amazonaws.com/#retrieve-an-order-with-token
export function fetchOrder(orderId, token) {
  return (dispatch) => api.fetch(`/orders/${orderId}?token=${token}&includeInvoiceLink=true`)
    .then((response) => {
      dispatch({ type: 'FETCH_ORDER_SUCCESS', response })
      return response
    })
    .catch((error) => error)
}
